import { selectMenuNode, addModule, addMenuNode, updateMenuNode, deleteMenuNode } from "../../api/config/modules/MenuManagement";

const state = {
    selectMenuNode: {},
    addModule: {},
    addMenuNode: {},
    updateMenuNode: {},
    deleteMenuNode: {}
};

const mutations = {
    SET_SELECTMENUNODE: (state, selectMenuNode) => {
        state.selectMenuNode = selectMenuNode;
    },
    SET_ADDMODULE: (state, addModule) => {
        state.addModule = addModule;
    },
    SET_ADDMENUNODE: (state, addMenuNode) => {
        state.addMenuNode = addMenuNode;
    },
    SET_UPDATEMENUNODE: (state, updateMenuNode) => {
        state.updateMenuNode = updateMenuNode;
    },
    SET_DELETEMENUNODE: (state, deleteMenuNode) => {
        state.deleteMenuNode = deleteMenuNode;
    },
};

const actions = {
    GET_SELECTMENUNODE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectMenuNode(data)
                .then((res) => {
                    commit("SET_SELECTMENUNODE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_ADDMODULE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            addModule(data)
                .then((res) => {
                    commit("SET_ADDMODULE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_ADDMENUNODE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            addMenuNode(data)
                .then((res) => {
                    commit("SET_ADDMENUNODE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEMENUNODE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateMenuNode(data)
                .then((res) => {
                    commit("SET_UPDATEMENUNODE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEMENUNODE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteMenuNode(data)
                .then((res) => {
                    commit("SET_DELETEMENUNODE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
